function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 0a4 4 0 014 4v1.171c1.166.412 2 1.523 2 2.829v4a3 3 0 01-3 3H3a3 3 0 01-3-3V8c0-1.306.835-2.418 2-2.83V4a4 4 0 014-4h1zm-.5 8A1.5 1.5 0 005 9.5v1a1.5 1.5 0 003 0v-1A1.5 1.5 0 006.5 8zM7 2H6a2 2 0 00-2 2v1h5V4a2 2 0 00-2-2z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLockClosed = function SvgLockClosed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LockClosed.5ced3739.svg";
export { ForwardRef as ReactComponent };